import React ,{useEffect }from 'react'
import './Dashboard.css'
import { useNavigate } from 'react-router-dom';
import MyCards from '../components/MyCards'
import { fetchShops ,setSelectedShop} from "../store/shopSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from '../store/userSlice';
import noDataImage from '../assets/images/undraw_Empty_re_opql.png';



export default function Dashboard() {
 
 
  const userString = sessionStorage.getItem('user');
  const user = JSON.parse(userString);


  const dispatch = useDispatch();
  const navigate=useNavigate();
   const {shops}=useSelector((state) => state.shop)
   useEffect(() => {
    if(user.role==='manager'){
      dispatch(fetchShops({ page: 1, limit: 50 }));

    }else{
      dispatch(fetchShops({ page: 1, limit: 50, users: user._id }));
    }
    dispatch(fetchUsers())
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);   

  const handleShareClick = (shop) => {
    dispatch(setSelectedShop(shop))
   navigate('/shopManagement')
  };

  const handleLearnMoreClick = (shop) => {
    dispatch(setSelectedShop(shop))
    navigate('/orders')
  };
  
  return (
    
    <div className="shopsContainer">
  
    {shops && shops.length > 0 ? (
     shops.map((shop) => (
    <div className="cards" key={shop._id}>
      <MyCards
        title={shop.name}
        image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRIDflxuxkDFBFNPaN9DLftO-49ET1WBgDkjw&s"
        description={
          <>
            <span>Location: {shop.location}</span><br />
            <span>Users: {shop.users.map(user => user.login).join(', ')}</span>
          </>
        }
        buttonText1="Manage Shop"
        buttonText2="Orders"
        onClickButton1={()=>{handleShareClick(shop)}}
        onClickButton2={()=>{handleLearnMoreClick(shop)}}
        maxWidth={400}
        imageHeight={200}
      />
    </div>
  ))
) : (
  <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <img
          src={noDataImage} // Path to your no-data image
          alt="No Data"
          style={{
            width: '100%',       // Ensure image scales with container width
            maxWidth: '500px',   // Set a maximum width to prevent it from growing too large
            height: 'auto',      // Maintain aspect ratio
            margin: '20px auto', // Center image with margin
            display: 'block'     // Ensure centering works with margin auto
          }}
        />
        <h2>No Records Found</h2>
      </div>
)}
  </div>
  )
}
  